import { forceInt, getCurrenLocaleObj } from '../functions';

(function($) {
    const giveawayV2Page = $('.GiveawayV2Page');
    if (!giveawayV2Page.length) return;

    // -- Facebook sign up event ---------------------------------------------
    // Only rendered after a new Webflow sign up (see
    // GiveawayV2PageController::webflow_redirect()). eventID matches the
    // Conversions API event sent from the Webflow webhook (see
    // SignUp::fireSignUpFbEvent()) so FB can dedupe them.
    const giveawaySendSignupFBEvent = $('#giveaway-send-signup-fb-event');
    if (giveawaySendSignupFBEvent.length && window.FBPixelDefined) {
        const fbEventIDSignUp = giveawaySendSignupFBEvent.data('fb-event-id');
        fbq('track', 'CompleteRegistration', {
            content_name: 'Giveaway Signed Up',
            giveaway_name: giveawaySendSignupFBEvent.data('giveaway-title'),
            giveaway_id: forceInt(giveawaySendSignupFBEvent.data('giveaway-id'))
        }, (fbEventIDSignUp ? { eventID: fbEventIDSignUp } : {}));
    }

    // -- Countdown ------------------------------------------------------
    // Ported from legends-hub-mockup/js/legends.js. The comp has no design
    // for 1 day, 0 days, or a closed giveaway — see states.html in the
    // mockup for the open question.
    const renderCountdown = function() {
        giveawayV2Page.find('[data-deadline]').each(function() {
            const $el = $(this),
                closes = new Date($el.data('deadline')),
                days = Math.floor((closes - new Date()) / 86400000);

            if (isNaN(days)) return;

            // A non-breaking space, not a plain one - .legend-progress__countdown
            // is display:flex, which can trim a plain space sitting between
            // inline content into an anonymous flex item boundary.
            if (days > 1) {
                $el.html('<b>' + days + ' days</b>&nbsp;left to enter');
            } else if (days === 1) {
                $el.html('<b>1 day</b>&nbsp;left to enter');
            } else if (days === 0) {
                $el.html('<b>Closes today</b>');
            } else {
                $el.html('<b>Entries closed</b>');
            }
        });
    };

    // -- Entry state ------------------------------------------------------
    // Rows (ladder <tr> and follow <a>) share id="giveaway-action-{ID}".
    // giveawaySignUpEntries is injected by Giveaway::IncludeJs() (see
    // GiveawayV2PageController::index()) and only covers the actions
    // rendered on this page (the hardcoded ladder/follow titles), so the
    // entries count itself always comes from the server-rendered total
    // ($SignUp.EntriesCount) — never recomputed client-side from the DOM,
    // since that total may include entries from actions this page doesn't
    // display a row for.
    const actionComplete = function(row) {
        row.addClass('is-earned');
    };

    const bumpEntriesCount = function(byAmount) {
        const $count = giveawayV2Page.find('.js-giveaway-entires-count');
        $count.text(forceInt($count.text()) + byAmount);
    };

    const updateEntries = function() {
        if (typeof giveawaySignUpEntries === 'object' && giveawaySignUpEntries && giveawaySignUpEntries.length) {
            giveawaySignUpEntries.forEach(entry => {
                const row = giveawayV2Page.find('#giveaway-action-' + entry.ActionID);
                actionComplete(row);
            });
        }
    };

    // -- Follow list: click credits an entry, the same way the original
    // GiveawayPage's click-to-earn does it (see giveawayPage.js) - validated
    // against giveawaySignUp's giveawayActions (injected by
    // Giveaway::IncludeJs(), same as the original page), not just the
    // clicked element's own data attributes.
    //
    // Mailing-list rows deliberately don't set data-url (consenting to join
    // credits an entry but no longer also opens the partner's URL), whereas
    // the podcast ladder row does (GiveawayV2Page::clickToEarnLadderActionIDs())
    // - it should open every click, not just the first, so that's read and
    // opened up front rather than being tied to the earned/credited check
    // below.
    const giveawayId = forceInt($('#main').data('giveaway-id'));

    giveawayV2Page.find('.js-giveaway-follow-row').on('click touch', function(e) {
        e.preventDefault();

        const $this = $(this),
            actionID = forceInt($this.data('id')),
            url = $this.data('url');

        if (url) {
            window.open(url, '_blank');
        }

        if (!actionID) return;

        const action = (typeof giveawayActions === 'object' && giveawayActions) ?
            giveawayActions.find(a => a.ID === actionID) : null;
        if (!action) return;

        if (!giveawayId || $this.hasClass('is-earned')) return;

        $.post('/giveaway-v2-controller/index/' + giveawayId + '/?l=' + getCurrenLocaleObj().locale, { actionID: action.ID }, function(data) {
            if (data.status === 1) {
                giveawaySignUpEntries = data.entries;
                actionComplete($this);
                bumpEntriesCount(forceInt(action.NumEntries));
            }
        }, 'json');
    });

    // -- Entry ladder: rows with a URL are clickable through to it, but the
    // ladder is purely informational - unlike follow rows, clicking never
    // credits an entry or ticks the row (the server wouldn't accept it
    // anyway, since every ladder action is one of GiveawayV2Page's
    // autoActionIDs()/default action, excluded from the AJAX endpoint).
    //
    // The webinar row is the one exception: it has no single URL to go to,
    // so instead of navigating, clicking it expands/collapses its
    // js-giveaway-ladder-row--expandable panel (GiveawayV2Page::
    // $webinar_options) - the links inside that panel are plain
    // target="_blank" anchors, so they need no click handling of their own.
    giveawayV2Page.find('.js-giveaway-ladder-row').on('click touch', function() {
        const $row = $(this);

        if ($row.hasClass('js-giveaway-ladder-row--expandable')) {
            const isExpanded = $row.attr('aria-expanded') === 'true';
            $row.attr('aria-expanded', String(!isExpanded));
            $('#' + $row.attr('aria-controls')).prop('hidden', isExpanded);
            return;
        }

        const url = $row.data('url');
        if (url) {
            window.open(url, '_blank');
        }
    });

    // -- Referral link "copy" button ---------------------------------------
    // Copies the SignUp's referral URL (data-copy-text) via the Clipboard
    // API, falling back to a hidden-textarea + execCommand for browsers/
    // contexts without it (e.g. non-HTTPS). The label swaps to "Copied!"
    // for 2s as visual confirmation.
    giveawayV2Page.find('.js-referral-link-copy').on('click', function() {
        const $btn = $(this);
        const text = $btn.data('copyText');
        if (!text) return;

        const copyFallback = function() {
            const $temp = $('<textarea readonly>').val(text).css({ position: 'fixed', top: '-9999px' });
            $('body').append($temp);
            $temp[0].select();
            document.execCommand('copy');
            $temp.remove();
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).catch(copyFallback);
        } else {
            copyFallback();
        }

        const $labelText = $btn.find('.js-referral-link-label-text');
        clearTimeout($btn.data('copyResetTimeout'));
        $btn.addClass('is-copied');
        $labelText.text('Copied!');
        const resetTimeout = setTimeout(function() {
            $btn.removeClass('is-copied');
            $labelText.text('Copy link');
        }, 2000);
        $btn.data('copyResetTimeout', resetTimeout);
    });

    renderCountdown();
    updateEntries();

})(jQuery);



// WEBPACK FOOTER //
// ./js/modules/giveawayV2Page.js